import { API, graphqlOperation } from 'aws-amplify';
import { listRankingCourseWithTag } from '@/graphql/custom';
import { config } from '@/config';

export const getRankings = async (company:string, rankings:any, tagid = '') => {
  if(!company) return {};

  const now = (new Date()).getTime();
  const ttl = now + (config.RANKING_TTL_HOUR * 60 * 60 * 1000);
  const tagk = (tagid == '' ? '#all#': tagid);

  const ls = sessionStorage.getItem(config.LSKEYWORD_RANKING);
  if(ls) {
    try {
      const rkobj = JSON.parse(ls);
      if(rkobj.company === company) {
        const rkall = rkobj.allRankings;
        if(Object.keys(rkall).includes(tagk)) {
          if (rkall[tagk].ttl > now) {
            rankings.value = rkall[tagk].rankings;
            return rkall[tagk].rankings;
          }
        }
      }
    } catch (e) {
      console.error(e);
      rankings.value = {};
      return {};
    }
  }

  const rk = await queryRanking(company, tagid);
  if(rk != null) {
    const refranking = {
      ttl: ttl,
      rankings: rk
    };

    const initRk = () => {return {
      company: company,
      allRankings: {}
    }};

    let rkobj:any;
    if(ls) {
      try {
        rkobj = JSON.parse(ls);
        if(rkobj.company != company) rkobj = initRk();
      } catch (e) {
        console.error(e);
        rkobj = initRk();
      }
    } else {
      rkobj = initRk();
    }
    rkobj.allRankings[tagk] = refranking;
    sessionStorage.setItem(config.LSKEYWORD_RANKING, JSON.stringify(rkobj));
    rankings.value = rk;
    return rk;
  } else {
    rankings.value = {};
    return {};
  }
};

// ランキング
const queryRanking = async (company:string, tagid:string) => {
  const params:{[key:string]: any} = {
    companyId: company,
    rankingType: 'all', // rankingTypes
    limit: config.RANKING_LIMIT,
    recentRange: config.RANKING_RECENT_RANGE_DAY
  };
  if(tagid != '') {
    params.tagId = tagid;
  }

  try {
    const res:any = await API.graphql(graphqlOperation(listRankingCourseWithTag, params));
    // console.log(res);
    const lRankings = res.data.listRankingCourse.items.reduce((r:any, c:any) => {
      if (r[c.rankingType] === undefined) r[c.rankingType] = [];
      r[c.rankingType].push({
        courseId: c.courseId,
        count: c.count,
        course: c.course
      });
      return r;
    }, {});
    Object.keys(lRankings).forEach((k:string) => lRankings[k].sort((a:any, b:any) => b.count - a.count));
    return lRankings;
  } catch(err) {
    console.warn(err);
    return null;
  }
};

// タグランキングのロード
export const getFrequentTags = (company:string) => {
  if(!company) return [];
  const now = (new Date()).getTime();

  const ls = sessionStorage.getItem(config.LSKEYWORD_FREQTAGS);
  if(ls) {
    try {
      const fqobj = JSON.parse(ls);
      if(fqobj.company === company && fqobj.ttl > now) {
        return fqobj.tags;
      }
    } catch (e) {
      console.error(e);
    }
  }
  return [];
};
// タグランキングのストア
export const storeFrequentTags = (company:string, frequentTags = []) => {
  if(!company) return;
  const now = (new Date()).getTime();
  const ttl = now + (config.RANKING_TTL_HOUR * 60 * 60 * 1000);
  sessionStorage.setItem(config.LSKEYWORD_FREQTAGS, JSON.stringify({
    company: company,
    ttl: ttl,
    tags: frequentTags
  }));

};